import React from "react";
import { QualityAlertItem } from "../../../models/weeklyTimeline";
import { Location as tqsLocation } from "../../../models/location";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTurnUp, faWarning, faLocationArrow } from "@fortawesome/free-solid-svg-icons";
import { getTimezoneTime } from "./utils";

interface QualityAlertItemProps {
  item: QualityAlertItem;
  timezone: string;
  bottomLastMargin: string;
  verticalLineStyle: string;
}

const QualityAlertItemComponent: React.FC<QualityAlertItemProps> = ({
  item,
  timezone,
  bottomLastMargin,
  verticalLineStyle,
}) => {
  return (
    <div className={`mt-1 flex flex-col ${bottomLastMargin}`}>
      <div className="flex flex-row">
        <div
          className={`flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full ${item.qualityAlert.level === 1 ? "bg-[#ff453a]" : "bg-green-400"}`}
        >
          {item.qualityAlert.level === 1 && <FontAwesomeIcon className="h-4 w-4 text-white" icon={faWarning} />}
          {item.qualityAlert.level != 1 && <FontAwesomeIcon className="h-4 w-4 text-white" icon={faLocationArrow} />}
        </div>
        <h1 className="ml-3 flex items-center justify-center text-sm">
          {item.qualityAlert.level === 1
            ? "Quality Alert Issued"
            : "Near Miss Issued"}{" "}
          #{item.qualityAlert.number}
        </h1>
      </div>
      <div className="flex flex-row items-stretch">
        <div className={`ml-[0.7rem] ${verticalLineStyle}`} />
        <div className="ml-6 flex flex-col">
          <h2 className="w-[70%] text-xs font-light text-gray-500">
            Proactively Sent to {item.locations.length} other OEM{" "}
            {item.locations.length === 1 ? "location" : "locations"} @{" "}
            {getTimezoneTime(item.time, timezone)} {timezone}
          </h2>
          <div>
            {item.locations.map((loc, i) => (
              <div
                key={i}
                className="relative flex h-8 w-full items-center"
              >
                <div className="absolute left-0 top-[5px] rotate-90">
                  <FontAwesomeIcon className="text-gray-500" icon={faTurnUp} />
                </div>
                <h2 className="flex h-[60%] flex-row items-center pl-6 pt-[0.3rem] text-[11px] font-light text-[#212322]">
                  {(loc.location as unknown as tqsLocation).name.length >
                  30
                    ? `${(loc.location as unknown as tqsLocation).name.substring(0, 27)}...`
                    : (loc.location as unknown as tqsLocation).name}
                  <span className="ml-1 h-full">
                    {loc.status === "New" && (
                      <div className="flex h-full flex-row items-center justify-center rounded-md border-[1px] border-[#30d158] bg-green-100 px-1">
                        <h3 className="ml-1 text-[0.6rem] text-[#30d158] whitespace-nowrap">
                          New
                        </h3>
                      </div>
                    )}
                    {loc.status === "Checking For Issue" && (
                      <div className="flex h-full flex-row items-center justify-center rounded-md border-[1px] border-[#9e9e9e] bg-gray-100 px-1">
                        <h3 className="ml-1 text-[0.6rem] text-[#9e9e9e] whitespace-nowrap">
                          Checking For Issue
                        </h3>
                      </div>
                    )}
                    {loc.status === "Issue Found" && (
                      <div className="flex h-full flex-row items-center justify-center rounded-md border-[1px] border-[#ff453a] bg-red-100 px-1">
                        <h3 className="ml-1 text-[0.6rem] text-[#ff453a] whitespace-nowrap">
                          Issue Found
                        </h3>
                      </div>
                    )}
                    {loc.status === "No Issue" && (
                      <div className="flex h-full flex-row items-center justify-center rounded-md border-[1px] border-[#30d158] bg-green-100 px-1">
                        <h3 className="ml-1 text-[0.6rem] text-[#30d158] whitespace-nowrap">
                          No Issue Found
                        </h3>
                      </div>
                    )}
                    {loc.status === "Closed" && (
                      <div className="flex h-full flex-row items-center justify-center rounded-md border-[1px] border-[#ff453a] bg-gray-100 px-1">
                        <h3 className="ml-1 text-[0.6rem] text-[#ff453a] whitespace-nowrap">
                        Closed
                        </h3>
                      </div>
                    )}
                  </span>
                </h2>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityAlertItemComponent; 